import React, { createContext, useContext, useState, useCallback } from "react";

const FullScreenContext = createContext();

export function useFullScreen() {
  return useContext(FullScreenContext);
}

export function FullScreenProvider({ children }) {
  const [isFullScreen, setIsFullScreen] = useState(false);

  const openFullScreen = useCallback(() => setIsFullScreen(true), []);
  const closeFullScreen = useCallback(() => setIsFullScreen(false), []);

  return (
    <FullScreenContext.Provider
      value={{ isFullScreen, openFullScreen, closeFullScreen }}
    >
      {children}
    </FullScreenContext.Provider>
  );
}
